export default ({ request }) => ({
    userTripReimbursementListApi(data = {}) {
      return request({
        url: '/financial/user/trip/reimbursement/list',
        method: 'POST',
        data,
      })
    },
  })
  